import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import type { AuthGuardData } from 'keycloak-angular';
import { createAuthGuard } from 'keycloak-angular';
import { inject } from '@angular/core';

const isAuthenticated = (
  _route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  { authenticated }: AuthGuardData,
): Promise<boolean | UrlTree> => Promise.resolve(authenticated ? true : inject(Router).parseUrl('/login'));

export const authGuard = createAuthGuard<CanActivateFn>(isAuthenticated);
